/**
 * Сообщает backend'у о заходе на сайт.
 *
 * Сайт отдаётся статикой, и без этого вызова сервер не знает, сколько людей
 * его открыли: часть уходит с первого экрана, не сделав ни одного запроса.
 * Раз на вкладку — переходы внутри SPA и обновления страницы заходом не
 * считаются. Никаких идентификаторов браузер не хранит: посетителя сервер
 * различает по хэшу с суточной солью, а здесь помнится только «уже сообщили».
 */
import { request } from "../api/client";
import type { RecordVisitRequest } from "../api/types";

const SENT_KEY = "chronoguessr:visit-sent";

export function recordVisit() {
  try {
    if (sessionStorage.getItem(SENT_KEY)) return;
    sessionStorage.setItem(SENT_KEY, "1");
  } catch {
    // Хранилище недоступно (приватный режим, запрет cookie): заход всё
    // равно учитываем, повторный при обновлении — меньшее из зол.
  }

  const body: RecordVisitRequest = {
    path: window.location.pathname,
    referrer: document.referrer,
  };
  // Метрика не должна мешать игре: ошибку не показываем и не повторяем.
  void request("/api/v1/visits", { method: "POST", body }).catch(() => undefined);
}
